import React, {Component} from "react";
import BoardCard from "./BoardCard";

export default class BoardCardTreeWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = { expanded: false };
        this.toggleTreeExpanded = this.toggleTreeExpanded.bind(this)
    }

    toggleTreeExpanded(e) {
        e.stopPropagation();
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        let {
            selectBoard,
            onHover,
            leaveHover,
            boardKey,
            isOwner,
            updateBoard,
            sidebarFormat,
            centerMap,
            campaign,
            board,
        } = this.props;
        let childBoards = board.childBoards || [];
        return (
            <>
                <BoardCard
                    selectBoard={selectBoard}
                    {...(onHover ? {onHover: () => onHover(boardKey)} : {})}
                    {...(leaveHover ? {leaveHover: () => leaveHover(boardKey)} : {})}
                    boardKey={boardKey}
                    isOwner={isOwner}
                    updateBoard={updateBoard}
                    sidebarFormat={sidebarFormat}
                    centerMap={centerMap}
                    campaign={campaign}
                    board={board}
                    expanded={this.state.expanded}
                    toggleExpanded={this.toggleTreeExpanded}
                    pin={this.props.pin}
                />
                {childBoards && this.state.expanded &&
                    <div className="tree-children">
                        {childBoards.map((b, index) => (
                            <BoardCard
                                selectBoard={selectBoard}
                                {...(onHover ? { onHover: () => onHover(b.vendorId) } : {})}
                                {...(leaveHover ? { leaveHover: () => leaveHover(b.vendorId)} : {})}
                                boardKey={b.vendorId}
                                isOwner={isOwner}
                                updateBoard={updateBoard}
                                sidebarFormat={sidebarFormat}
                                centerMap={centerMap}
                                campaign={campaign}
                                board={b}
                                key={index}
                                child
                            />
                        ))}
                    </div>
                }
            </>
        );
    }
}
